/* 项目管理 */
const layoutComponent = () => import('@/views/layout')

export default [{
  path: '/projectManagement',
  component: layoutComponent,
  meta: {
    title: 'menu.projectManagement',
    icon: 'el-icon-ali-ProjectManagement'
  },
  children: [
    {
      path: '/projectManagement/index',
      name: 'index',
      component: () => import('@/views/projectManagement/index.vue'),
      meta: {
        title: '',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectListView',
      name: 'projectListView',
      component: () => import('@/views/projectManagement/projectListView.vue'),
      meta: {
        title: 'menu.projectManagement',
        buttons: [
          { code: 'scan', name: '浏览' },
          { code: 'add', name: '新增' },
          { code: 'delete', name: '删除' },
          { code: 'edit', name: '编辑' },
          { code: 'view', name: '查看' },
          { code: 'enable', name: '启用' },
          { code: 'disable', name: '禁用' },
          { code: 'import', name: '导入' },
          { code: 'assign', name: '分配' },
          { code: 'viewProcess', name: '查看过程' },
          { code: 'editProcess', name: '编辑过程' },
          { code: 'plan', name: '计划' },
          { code: 'implementing', name: '执行' },
        ]
      }
    },
    {
      path: '/projectManagement/projectProcessView',
      name: 'projectProcessView',
      component: () => import('@/views/projectManagement/projectProcessView'),
      meta: {
        title: 'menu.projectProcessView',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectProcessEdit',
      name: 'projectProcessEdit',
      component: () => import('@/views/projectManagement/projectProcessEdit'),
      meta: {
        title: 'menu.projectProcessEdit',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectProcessExcute',
      name: 'projectProcessExcute',
      component: () => import('@/views/projectManagement/projectProcessExcute'),
      meta: {
        title: 'menu.projectProcessExcute',
        routeNameParent: 'projectListView'
      }
    },

    {
      path: '/projectManagement/projectUserDataView',
      name: 'projectUserDataView',
      component: () => import('@/views/projectManagement/projectUserDataView.vue'),
      meta: {
        title: 'menu.userDataAccess',
        buttons: [
          { code: 'view', name: '查看' },
          { code: 'assign', name: '分配' }
        ]
      }
    },
    {
      path: '/projectManagement/projectUserInfoView',
      name: 'projectUserInfoView',
      component: () => import('@/views/projectManagement/projectUserInfoView.vue'),
      meta: {
        title: 'menu.userDataAccess',
        routeNameParent: 'projectUserDataView'
      }
    },
    {
      path: '/projectManagement/projectUserDataViewDetail',
      name: 'projectUserDataViewDetail',
      component: () => import('@/views/projectManagement/projectUserDataViewDetail.vue'),
      meta: {
        title: 'menu.projectUserDataViewDetail',
        routeNameParent: 'projectUserDataView'
      }
    },
    {
      path: '/projectManagement/projectAddEditView',
      name: 'projectAddEditView',
      component: () => import('@/views/projectManagement/projectAddEditView.vue'),
      meta: {
        title: 'menu.projectAddEditView',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectAdd',
      name: 'projectAdd',
      component: () => import('@/views/projectManagement/projectAddEditView.vue'),
      meta: {
        title: 'menu.projectAdd',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectView',
      name: 'projectView',
      component: () => import('@/views/projectManagement/projectAddEditView.vue'),
      meta: {
        title: 'menu.projectView',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectUpdatePlanView',
      name: 'projectUpdatePlanView',
      component: () => import('@/views/projectManagement/projectUpdatePlanView.vue'),
      meta: {
        title: 'menu.projectUpdatePlanView',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectPopUpView',
      name: 'projectPopUpView',
      component: () => import('@/views/projectManagement/projectPopUpView.vue'),
      meta: {
        title: 'menu.userDataAccess',
        routeNameParent: 'projectListView'
      }
    },
    {
      path: '/projectManagement/projectAdministratorView',
      name: 'projectAdministratorView',
      component: () => import('@/views/projectManagement/projectAdministratorView.vue'),
      meta: {
        title: '',
        routeNameParent: 'projectListView'
      }
    }
  ]
}]
